<template>
    <svg data-v-4c034fe6="" xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-svg feather feather-users"><path data-v-4c034fe6="" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle data-v-4c034fe6="" cx="9" cy="7" r="4"></circle><path data-v-4c034fe6="" d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path data-v-4c034fe6="" d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
</template>

<script>
export default {
  name: "UsersIcon"
}
</script>